var map = {
	"./WP_000072.jpg": 995390,
	"./WP_000074.jpg": 227496,
	"./WP_000203.jpg": 578820,
	"./WP_000240.jpg": 406535,
	"./WP_000275.jpg": 280611,
	"./WP_000293.jpg": 693195,
	"./WP_000295.jpg": 661269,
	"./WP_000317.jpg": 968942,
	"./WP_000359.jpg": 315236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32674;